import { z } from 'zod';

export const ClientRuntimeConfigSchema = z.object({
  useMockAuth: z.boolean(),
  publicBaseUrl: z.string().url().optional(),
  firebase: z.object({
    apiKey: z.string().min(1).optional(),
    appId: z.string().min(1).optional(),
    authDomain: z.string().min(1).optional(),
    measurementId: z.string().min(1).optional(),
    projectId: z.string().min(1).optional(),
  }),
});
export type ClientRuntimeConfig = z.infer<typeof ClientRuntimeConfigSchema>;
